import { useCallback, useState } from 'react';
import { TRACKING_EVENT_NAME, TRACKING_NAMESPACE, TRACKING_SCREEN } from '../constants/tracking';
export function useSmartPropertyCitationPanelState({
  onTrack,
  onOpenSmartPropertyCitationPanel
}) {
  const [panelOpen, setPanelOpen] = useState(false);
  const [panelTab, setPanelTab] = useState('activity');
  const handleOpenPanel = useCallback((tab, smartPropertyResultId) => {
    setPanelTab(tab);
    onTrack === null || onTrack === void 0 || onTrack(TRACKING_NAMESPACE, TRACKING_EVENT_NAME, {
      screen: TRACKING_SCREEN,
      subscreen: tab,
      action: 'citation panel opened',
      type: 'smartPropertyResultId'
    });
    if (onOpenSmartPropertyCitationPanel) {
      onOpenSmartPropertyCitationPanel(smartPropertyResultId);
    } else {
      setPanelOpen(true);
    }
  }, [onOpenSmartPropertyCitationPanel, onTrack]);
  const handleClosePanel = useCallback(() => {
    setPanelOpen(false);
  }, []);
  return {
    panelOpen,
    panelTab,
    handleOpenPanel,
    handleClosePanel
  };
}